var _path, _line, _line2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceMicrophoneLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    enableBackground: "new 0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M16.7,25.3V30c0,7.3,5.9,13.3,13.3,13.3S43.3,37.3,43.3,30v-4.7"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 30,
    y1: 43.3,
    x2: 30,
    y2: 53.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 21.9,
    y1: 53.4,
    x2: 38.4,
    y2: 53.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "black",
    stroke: "black",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M22.9,28.1H30c0.6,0,1-0.4,1-1s-0.4-1-1-1h-7.1l0,0v-2l0,0H30c0.6,0,1-0.4,1-1s-0.4-1-1-1h-7.1l0,0v-2l0,0H30c0.6,0,1-0.4,1-1 s-0.4-1-1-1h-7.1l0,0v-2l0,0H30c0.6,0,1-0.4,1-1s-0.4-1-1-1h-7.1l0,0V12c0-3.9,3.2-7.1,7.1-7.1s7.1,3.2,7.1,7.1v18 c0,3.9-3.2,7.1-7.1,7.1s-7.1-3.2-7.1-7.1L22.9,28.1L22.9,28.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceMicrophoneLight);
export default __webpack_public_path__ + "static/media/device-microphone-light.526837ee325a4ad15c5baf1f11b453e6.svg";
export { ForwardRef as ReactComponent };